import { useQuery } from '@apollo/client';
import { get } from 'lodash-es';
import { useEffect } from 'react';
import { useLocationQueryParams } from './useLocationQueryParams';
export function useFolderQueryFromParam(gqlGetFolderQuery, history) {
    const urlParams = useLocationQueryParams();
    const folderResponse = useQuery(gqlGetFolderQuery, {
        variables: { id: urlParams.folderId },
        skip: !urlParams.folderId,
    });
    const isLoadingFolder = folderResponse.loading;
    const maybeFolder = get(folderResponse, 'data.folder');
    useEffect(() => {
        // If the page loaded with a folderId that does not resolve to a folder, just
        // redirect to the default project creation state
        if (!maybeFolder && !isLoadingFolder) {
            history.replace(history.location.pathname);
        }
    }, [history, isLoadingFolder, maybeFolder]);
    return {
        folder: maybeFolder,
        isLoading: isLoadingFolder,
    };
}
